import { Plane, Route, Clock } from "lucide-react";
import { Reveal } from "./anim";
import { IMAGES } from "./config";

const chapters = [
  {
    n: "01",
    title: "Transferts aéroport & gare",
    desc: "Accueil personnalisé, suivi de votre vol en temps réel et prise en charge de vos bagages. Montpellier, Béziers-Cap d'Agde, Toulouse, Marseille — vous voyagez, on s'occupe du reste.",
    icon: Plane,
    img: IMAGES.airport,
  },
  {
    n: "02",
    title: "Longue distance",
    desc: "Un trajet interurbain confortable et sans stress, à bord d'une berline haut de gamme. Sièges spacieux, silence feutré et itinéraire optimisé pour arriver reposé.",
    icon: Route,
    img: IMAGES.road,
  },
  {
    n: "03",
    title: "Trajets locaux & mise à disposition",
    desc: "Soirées, événements, rendez-vous professionnels ou mise à disposition à l'heure : votre chauffeur reste à votre entière disposition, avec discrétion et ponctualité.",
    icon: Clock,
    img: IMAGES.portrait,
  },
];

const Services = () => (
  <section id="services" data-testid="services-section" className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40">
    <Reveal>
      <div className="mb-20 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="mb-4 text-xs uppercase tracking-[0.3em] text-rose">Nos prestations</p>
          <h2 className="font-serif text-4xl leading-tight tracking-tight sm:text-6xl text-blush max-w-xl">
            Chaque trajet, pensé dans le moindre détail.
          </h2>
        </div>
        <p className="max-w-xs text-sm leading-relaxed text-muted-foreground">
          Un service de chauffeur privé sur mesure, disponible {"24H/24 et 7J/7"} dans tout l'Hérault et l'Occitanie.
        </p>
      </div>
    </Reveal>

    <div className="flex flex-col">
      {chapters.map((c, i) => (
        <Reveal key={c.n} delay={i * 0.05}>
          <div
            data-testid={`service-${c.n}`}
            className="group grid grid-cols-1 items-center gap-8 border-t border-white/10 py-12 md:grid-cols-12 md:gap-10 md:py-16"
          >
            <div className="md:col-span-1 font-serif text-3xl text-blush/40">{c.n}</div>
            <div className="md:col-span-4">
              <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-full border border-rose/40 text-rose transition-colors group-hover:bg-rose/10">
                <c.icon size={18} />
              </div>
              <h3 className="font-serif text-3xl tracking-tight text-blush sm:text-4xl">{c.title}</h3>
            </div>
            <p className="md:col-span-4 text-sm leading-relaxed text-muted-foreground">{c.desc}</p>
            <div className="md:col-span-3 overflow-hidden rounded-xl">
              <img
                src={c.img}
                alt={c.title}
                className="h-44 w-full object-cover grayscale-[0.2] transition-transform duration-700 ease-out group-hover:scale-110 md:h-32"
              />
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Services;
